import React, { useContext } from "react";
import { ActionButton, Block, Col, FormCheckbox, Row } from "../../../components/Component";

import { useState } from "react";
import { listHospitalAPI } from "../clients/hospital/HospitalTableData";
import { ServerStatusType } from "../../../utils";
import { useEffect } from "react";
import { Form, Spinner } from "reactstrap";
import { CarerWizardContext } from "./AddCarer";
import { CarerPreviousButton } from "../../../components/button/ActionButton";

const CarerHospital = ({ onNext, onPrev, isValid }) => {
  const { data, updateData } = useContext(CarerWizardContext);
  const [hospitalList, setHospitalList] = useState([]);
  const [loadingDetail, setLoadingDetail] = useState(true);
  const [selectAllChecked, setSelectAllChecked] = useState(false);
  const [itHasChanges, setItHasChanges] = useState(false);
  const formattedTrusts = hospitalList
    ?.map((item) => ({
      id: item?.trust?.id,
      value: item?.trust?.value,
      label: item?.trust?.label,
    }))
    .filter(
      (value, index, self) =>
        index ===
        self.findIndex(
          (t) => t.value === value.value && t.id !== undefined && t.value !== undefined && t.label !== undefined
        )
    );

  const otherHospitals = hospitalList.filter((hospital) => {
    return !formattedTrusts.some((trust) => trust.id === hospital?.trust?.id);
  });

  useEffect(() => {
    loadHospital();
  }, []);

  // useEffect(() => {
  //   setSelectAllChecked(!hospitalList.map((item) => item?.id).some((item) => data?.hospital?.includes(item)));
  //   isValid(false, itHasChanges);
  // }, [hospitalList, data]);
  useEffect(() => {
    setSelectAllChecked(hospitalList.every((item) => data?.hospital?.includes(item.id)));
    isValid(false, itHasChanges);
  }, [hospitalList, data]);

  const handleSelectAllChange = (e) => {
    setItHasChanges(true);
    const isChecked = e.target.checked;
    setSelectAllChecked(isChecked);
    const updatedHospitalList = isChecked ? hospitalList.map((item) => item.id) : [];
    updateData("hospital", updatedHospitalList);
  };

  const handleTrustChange = (trustItem, e) => {
    setItHasChanges(true);
    const isChecked = e.target.checked;
    let updatedList = [...data.hospital];

    hospitalList
      .filter((item) => item?.trust?.id === trustItem.id)
      .forEach((hospitalItem) => {
        if (isChecked) {
          if (!updatedList.includes(hospitalItem.id)) {
            updatedList.push(hospitalItem.id);
          }
        } else {
          updatedList = updatedList.filter((id) => id !== hospitalItem.id);
        }
      });
    updateData("hospital", updatedList);
  };

  const handleOtherChange = (e) => {
    setItHasChanges(true);
    const isChecked = e.target.checked;
    let updatedList = [...data.hospital];

    if (isChecked) {
      otherHospitals.forEach((hospital) => {
        if (!updatedList.includes(hospital.id)) {
          updatedList.push(hospital.id);
        }
      });
    } else {
      updatedList = updatedList.filter((id) => !otherHospitals.some((hospital) => hospital.id === id));
    }

    updateData("hospital", updatedList);
  };

  const handleOtherHospitalChange = (e, hospitalId) => {
    setItHasChanges(true);
    const isChecked = e.target.checked;
    let updatedList = [...data.hospital];

    if (isChecked) {
      updatedList.push(hospitalId);
    } else {
      updatedList = updatedList.filter((id) => id !== hospitalId);
    }

    updateData("hospital", updatedList);
  };

  function loadHospital() {
    setLoadingDetail(true);
    listHospitalAPI(
      {
        clientType: "HOSPITAL",
        status: ServerStatusType.active,
      },
      (list, error) => {
        if (error === null) {
          setHospitalList(list?.list);
        }
        setLoadingDetail(false);
      }
    );
  }

  return (
    <div>
      <Form>
        {loadingDetail ? (
          <div className="spinner d-flex justify-content-center">
            <Spinner size="sm" color="primary" />
          </div>
        ) : (
          <React.Fragment>
            <Row>
              <FormCheckbox
                id="SelectAll"
                name="Select All"
                label="Select All"
                labelClassName="fw-bold"
                checked={selectAllChecked}
                onChange={handleSelectAllChange}
              />
              <Col className="col-12">
                {formattedTrusts?.map((trustItem, id) => {
                  const allHospitalsChecked = hospitalList
                    ?.filter((item) => item?.trust?.id === trustItem?.id)
                    .every((hospital) => data?.hospital.includes(hospital.id));
                  return (
                    <React.Fragment key={id}>
                      <Col className="col-12 col-sm-6">
                        <div className="form-group">
                          <FormCheckbox
                            label={trustItem?.label}
                            labelClassName="fw-bold"
                            id={"status" + id}
                            name="status"
                            checked={allHospitalsChecked}
                            onChange={(e) => handleTrustChange(trustItem, e)}
                          />
                        </div>
                      </Col>
                      <Row className="m-2">
                        {hospitalList
                          ?.filter((item) => item?.trust?.id === trustItem?.id)
                          .map((hospitalItem, index) => (
                            <React.Fragment key={index}>
                              <Col className="col-12 col-sm-6">
                                <FormCheckbox
                                  id={"Hospital" + index}
                                  required={false}
                                  name={hospitalItem?.name}
                                  label={hospitalItem?.name}
                                  checked={data?.hospital.includes(hospitalItem.id)}
                                  onChange={(e) => {
                                    setItHasChanges(true);
                                    let updatedList = [...data.hospital];
                                    if (e.target.checked) {
                                      updatedList.push(hospitalItem.id);
                                    } else {
                                      updatedList = updatedList.filter((id) => id !== hospitalItem.id);
                                    }
                                    updateData("hospital", updatedList);
                                  }}
                                />
                              </Col>
                            </React.Fragment>
                          ))}
                      </Row>
                    </React.Fragment>
                  );
                })}
                {otherHospitals?.map((hospitalItem, index) => {
                  const allOtherHospitalsChecked = hospitalList
                    ?.filter((item) => item?.trust?.id === hospitalItem?.trust?.id)
                    .every((hospital) => data?.hospital.includes(hospital.id));
                  return (
                    <React.Fragment key={index}>
                      {index === 0 && (
                        <>
                          <Col className="col-12 col-sm-6">
                            <div className="form-group">
                              <FormCheckbox
                                label={"Other"}
                                labelClassName="fw-bold"
                                id={"otherHomeCare"}
                                name="status"
                                checked={allOtherHospitalsChecked}
                                onChange={handleOtherChange}
                              />
                            </div>
                          </Col>
                          <Row className="m-2">
                            {otherHospitals.map((hospitalItem, index) => (
                              <React.Fragment key={index}>
                                <Col className="col-12 col-sm-6">
                                  <FormCheckbox
                                    id={"OtherHospital" + index}
                                    required={false}
                                    name={hospitalItem?.name}
                                    label={hospitalItem?.name}
                                    checked={data?.hospital.includes(hospitalItem.id)}
                                    onChange={(e) => handleOtherHospitalChange(e, hospitalItem.id)}
                                  />
                                </Col>
                              </React.Fragment>
                            ))}
                          </Row>
                        </>
                      )}
                    </React.Fragment>
                  );
                })}
              </Col>
            </Row>
          </React.Fragment>
        )}
      </Form>
      <Block className="text-end mt-3">
        <ul className="align-center justify-content-end flex-wrap flex-sm-nowrap gx-2 gy-2">
          <li>
            <CarerPreviousButton
              // type="submit"
              className="w-100px"
              title="Back"
              size="md"
              onClick={() => onPrev()}
            />
          </li>
          <li>
            <ActionButton
              //   disabled={isDisable}
              // type="submit"
              className="w-120px"
              title="Save & Next"
              size="md"
              onClick={() => onNext()}
              //   onClick={() => onFormSubmit()}
            />
          </li>
        </ul>
      </Block>
    </div>
  );
};

export default CarerHospital;
